module.exports = __webpack_public_path__ + "static/img/19012B_4_5_V_20230821_fit.9ebfc87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19012B_4_5_V_20230821_fit.png
// module id = 1Lh0
// module chunks = 0